import { fetchSplashData } from '../modules/splashSlice';
import { loginUser, logoutUser } from '../auth/authActions';

const isApiAction = (action) => {
    return action.type.includes('fetch') || action.type.includes('get') || action.type.includes('post');
};

const isSplashAction = (action) => {
    return action.type === fetchSplashData.pending.type || 
           action.type === fetchSplashData.fulfilled.type || 
           action.type === fetchSplashData.rejected.type;
};

export const splashMiddleware = (store) => (next) => (action) => {
    const state = store.getState();
    const { initialized } = state.splash;

    // Handle login success - fetch splash data to get user permissions
    if (action.type === loginUser.fulfilled.type) {
        const result = next(action);
        // Fetch splash data after successful login
        store.dispatch(fetchSplashData());
        return result;
    }

    // Handle logout - let it pass through (splash will be reset by reducer)
    if (action.type === logoutUser.fulfilled.type || action.type === logoutUser.rejected.type) {
        return next(action);
    }

    // If it's not an API action, let it pass through
    if (!isApiAction(action)) {
        return next(action);
    }

    // If it's a splash action, let it pass through
    if (isSplashAction(action)) {
        return next(action);
    }

    // If splash is not initialized, dispatch splash fetch and block the current action
    if (!initialized) {
        store.dispatch(fetchSplashData());
        return;
    }

    // If splash is initialized, allow the action to proceed
    return next(action);
}; 